import { RouteConfig } from "vue-router";

const ingresos: RouteConfig = {
  path: "/ingresos",
  name: "ingresos",
  component: () => import(/* webpackChunkName: "ingresos" */ "@/views/Ingresos.vue"),
};

export default ingresos;
